export const SGW_BID_INCREMENT_LIMIT = 99.99
